module.exports = __webpack_public_path__ + "img/otopack150-active.ce0e51dd.svg";